import React, { useState, useEffect, useCallback } from 'react';
import { Card, Table, Tag, Select, Input, Button, Space, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { adminAPI } from '../api/admin';

const { Search } = Input;

const TYPE_LABELS = {
  waitlist_success: 'ثبت‌نام لیست انتظار',
  invitation: 'دعوت‌نامه',
  otp: 'کد یکبار مصرف'
};

export default function SMSLogManager() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ type: undefined, success: undefined, phone: '' });

  const fetchList = useCallback(async (targetPage = page) => {
    setLoading(true);
    try {
      const params = { page: targetPage, limit };
      if (filters.type) params.type = filters.type;
      if (filters.success !== undefined) params.success = filters.success;
      if (filters.phone) params.phone = filters.phone;
      const { data } = await adminAPI.getSMSLogs(params);
      setItems(data.items || []);
      setTotal(data.total || 0);
    } catch (e) {
      message.error('خطا در دریافت لاگ پیامک‌ها');
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, filters]);

  useEffect(() => {
    fetchList(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filters]);

  const columns = [
    { title: 'زمان', dataIndex: 'createdAt', width: 160, render: (v) => moment(v).format('YYYY-MM-DD HH:mm:ss') },
    { title: 'شماره', dataIndex: 'phone', width: 140 },
    { title: 'نوع', dataIndex: 'type', width: 160, render: (t) => <Tag>{TYPE_LABELS[t] || t}</Tag> },
    {
      title: 'وضعیت ارسال',
      dataIndex: 'success',
      width: 130,
      render: (s) => s ? <Tag color="success">موفق</Tag> : <Tag color="error">ناموفق</Tag>
    },
    { title: 'خطا', dataIndex: 'error', render: (e) => e || '—' }
  ];

  return (
    <div>
      <Card
        size="small"
        style={{ marginBottom: 16 }}
        title="فیلترها"
        extra={<Button icon={<ReloadOutlined />} onClick={() => fetchList(page)}>بروزرسانی</Button>}
      >
        <Space wrap>
          <Select
            allowClear
            placeholder="نوع"
            style={{ width: 180 }}
            value={filters.type}
            onChange={(v) => { setPage(1); setFilters((f) => ({ ...f, type: v })); }}
            options={Object.entries(TYPE_LABELS).map(([value, label]) => ({ value, label }))}
          />
          <Select
            allowClear
            placeholder="وضعیت"
            style={{ width: 140 }}
            value={filters.success}
            onChange={(v) => { setPage(1); setFilters((f) => ({ ...f, success: v })); }}
            options={[
              { value: 'true', label: 'فقط موفق' },
              { value: 'false', label: 'فقط ناموفق' }
            ]}
          />
          <Search
            placeholder="جستجوی شماره تلفن..."
            style={{ width: 220 }}
            allowClear
            onSearch={(v) => { setPage(1); setFilters((f) => ({ ...f, phone: v })); }}
          />
        </Space>
      </Card>

      <Card size="small">
        <Table
          rowKey="_id"
          columns={columns}
          dataSource={items}
          loading={loading}
          pagination={{ current: page, pageSize: limit, total, showSizeChanger: false, onChange: setPage }}
        />
      </Card>
    </div>
  );
}
